import { uuid } from '@/helpers/tools'

export default class TokenStorage {
    private readonly traceId: string = uuid().replaceAll('-', '')

    getTraceId (): string {
        return this.traceId
    }
}
